/* ============================================
   TORREY CANDLE CO. — Theme JS
   Sticky nav, cart drawer, mobile menu,
   accordions, gallery, cart AJAX
   ============================================ */

(function () {
  'use strict';

  // ── STICKY HEADER ──────────────────────────────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── MOBILE MENU ────────────────────────────────────────────────────────────
  const mobileMenu   = document.getElementById('mobile-menu');
  const menuOverlay  = document.getElementById('mobile-menu-overlay');
  const menuOpen     = document.getElementById('mobile-menu-open');
  const menuClose    = document.getElementById('mobile-menu-close');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    menuClose && menuClose.focus();
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    menuOpen && menuOpen.focus();
  }

  menuOpen   && menuOpen.addEventListener('click', openMobileMenu);
  menuClose  && menuClose.addEventListener('click', closeMobileMenu);
  menuOverlay && menuOverlay.addEventListener('click', closeMobileMenu);

  // ── CART DRAWER ────────────────────────────────────────────────────────────
  const cartDrawer    = document.getElementById('cart-drawer');
  const cartOverlay   = document.getElementById('cart-drawer-overlay');
  const cartClose     = document.getElementById('cart-drawer-close');
  const cartItemsEl   = document.getElementById('cart-drawer-items');
  const cartFooterEl  = document.getElementById('cart-drawer-footer');
  const cartEmptyEl   = document.getElementById('cart-drawer-empty');
  const cartTotalEl   = document.getElementById('cart-drawer-total');

  function openCartDrawer() {
    if (!cartDrawer) return;
    fetchAndRenderCart();
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    cartClose && cartClose.focus();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartClose   && cartClose.addEventListener('click', closeCartDrawer);
  cartOverlay && cartOverlay.addEventListener('click', closeCartDrawer);

  // Open cart drawer from any [data-cart-open] element
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openCartDrawer();
    }
  });

  // Escape key closes drawers
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeCartDrawer();
    }
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchAndRenderCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(renderCart)
      .catch(console.error);
  }

  function renderCart(cart) {
    if (!cartItemsEl) return;

    updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
      cartItemsEl.innerHTML = '';
      cartFooterEl && (cartFooterEl.hidden = true);
      cartEmptyEl  && (cartEmptyEl.hidden = false);
      return;
    }

    cartFooterEl && (cartFooterEl.hidden = false);
    cartEmptyEl  && (cartEmptyEl.hidden = true);

    if (cartTotalEl) {
      cartTotalEl.textContent = formatMoney(cart.total_price);
    }

    cartItemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-drawer__item" data-key="${item.key}">
        <img
          src="${item.image || ''}"
          alt="${item.product_title}"
          class="cart-drawer__item-image"
          width="80" height="80"
          loading="lazy"
        >
        <div>
          <div class="cart-drawer__item-name">${item.product_title}</div>
          <div class="cart-drawer__item-price">${formatMoney(item.final_price)}</div>
          <div class="cart-drawer__item-qty">
            <button class="cart-drawer__qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Remove one">−</button>
            <span class="cart-drawer__qty-val">${item.quantity}</span>
            <button class="cart-drawer__qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Add one">+</button>
          </div>
          <button class="cart-drawer__item-remove" data-key="${item.key}" data-qty="0">Remove</button>
        </div>
        <div class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</div>
      </div>
    `).join('');
  }

  // Qty change / remove
  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('.cart-drawer__qty-btn, .cart-drawer__item-remove');
    if (!qtyBtn) return;
    const key = qtyBtn.dataset.key;
    const qty = parseInt(qtyBtn.dataset.qty, 10);
    updateCartItem(key, qty);
  });

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(r => r.json())
      .then(renderCart)
      .catch(console.error);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // Add to cart
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-atc-btn]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(r => r.json())
      .then(() => {
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Added!';
          setTimeout(() => { btn.textContent = 'Add to Cart'; }, 2000);
        }
        openCartDrawer();
      })
      .catch(() => {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
      });
  });

  // Quick-add from product card
  document.addEventListener('click', (e) => {
    const quickAdd = e.target.closest('[data-quick-add]');
    if (!quickAdd) return;
    e.preventDefault();
    const variantId = quickAdd.dataset.quickAdd;
    if (!variantId) return;
    const orig = quickAdd.textContent;
    quickAdd.disabled = true;
    quickAdd.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(r => r.json())
      .then(() => {
        quickAdd.textContent = 'Added!';
        setTimeout(() => { quickAdd.disabled = false; quickAdd.textContent = orig; }, 2000);
        openCartDrawer();
      })
      .catch(() => { quickAdd.disabled = false; quickAdd.textContent = orig; });
  });

  // ── ACCORDIONS ─────────────────────────────────────────────────────────────
  // Native <details> used — just ensure open-by-default on desktop for product
  function initAccordions() {
    const accordionItems = document.querySelectorAll('.accordion-item');
    accordionItems.forEach(item => {
      const trigger = item.querySelector('.accordion-item__trigger');
      if (!trigger) return;
      // Open first accordion on desktop
      if (window.innerWidth >= 1024 && item.dataset.defaultOpen === 'true') {
        item.open = true;
      }
    });
  }
  initAccordions();

  // ── FAQ ACCORDION ───────────────────────────────────────────────────────────
  // Also native <details> — no extra JS needed

  // ── PRODUCT GALLERY ─────────────────────────────────────────────────────────
  function initGallery() {
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;
    const mainImg  = gallery.querySelector('.product-gallery__main-image');
    const thumbs   = gallery.querySelectorAll('.product-gallery__thumb');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src  = thumb.dataset.src;
        const alt  = thumb.dataset.alt || '';
        if (mainImg && src) {
          mainImg.src = src;
          mainImg.srcset = src;   // Override Shopify's srcset so the new src takes effect
          mainImg.sizes = '100vw';
          mainImg.alt = alt;
        }
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
      thumb.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          thumb.click();
        }
      });
    });
  }
  initGallery();

  // ── EMAIL SIGNUP FORM ───────────────────────────────────────────────────────
  // Forms submit natively to Shopify (/contact, form_type=customer) so emails
  // are actually saved as customers tagged "newsletter". JS only handles the
  // post-submit success state (Shopify redirects back with ?customer_posted=true).
  if (window.location.search.includes('customer_posted=true')) {
    document.querySelectorAll('[data-email-form]').forEach(form => {
      const btn = form.querySelector('button[type="submit"]');
      const input = form.querySelector('input[type="email"]');
      if (btn) { btn.disabled = true; btn.textContent = '✓ Joined'; }
      if (input) { input.value = ''; input.placeholder = 'Thanks — you\'re on the list!'; }
    });
  }

  // ── COPY LINK ───────────────────────────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const copyBtn = e.target.closest('[data-copy-link]');
    if (!copyBtn) return;
    navigator.clipboard.writeText(window.location.href).then(() => {
      const orig = copyBtn.getAttribute('aria-label');
      copyBtn.setAttribute('aria-label', 'Copied!');
      setTimeout(() => copyBtn.setAttribute('aria-label', orig), 2000);
    }).catch(() => {});
  });

  // ── COLLECTION FILTER ───────────────────────────────────────────────────────
  function initCollectionFilter() {
    const filterBtns  = document.querySelectorAll('.collection-filter-btn');
    const productCards = document.querySelectorAll('[data-scent-family]');

    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const filter = btn.dataset.filter;
        filterBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        productCards.forEach(card => {
          const family = (card.dataset.scentFamily || '').toLowerCase();
          if (filter === 'all' || family.includes(filter)) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });

    const sortSelect = document.querySelector('.collection-sort__select');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const val = sortSelect.value;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', val);
        window.location.href = url.toString();
      });
    }
  }
  initCollectionFilter();

  // ── NOTIFY ME (sold out) ────────────────────────────────────────────────────
  // Opens a pre-filled email so the request actually reaches the shop inbox.
  // Swap for Klaviyo back-in-stock (free tier) when email marketing is wired up.
  document.addEventListener('click', (e) => {
    const notifyBtn = e.target.closest('[data-notify-me]');
    if (!notifyBtn) return;
    const subject = encodeURIComponent('Back-in-stock request');
    const body = encodeURIComponent('Hi! Please notify me when this candle is back in stock: ' + window.location.href);
    window.location.href = 'mailto:hello@torreycandleco.com?subject=' + subject + '&body=' + body;
  });

  // ── FULL CART PAGE (qty +/− and remove) ─────────────────────────────────────
  const cartPage = document.querySelector('.cart-page');
  if (cartPage) {
    cartPage.addEventListener('click', (e) => {
      const btn = e.target.closest('.qty-selector__btn, [data-remove-item]');
      if (!btn) return;
      const itemEl = btn.closest('.cart-item');
      if (!itemEl) return;
      const key = itemEl.dataset.key;
      let qty = 0;
      if (btn.classList.contains('qty-selector__btn')) {
        const valEl = itemEl.querySelector('.qty-selector__val');
        const current = parseInt(valEl ? valEl.textContent : '0', 10) || 0;
        qty = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      }
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(r => r.json())
        .then(() => window.location.reload())
        .catch(() => { btn.disabled = false; });
    });
  }

  // ── ANNOUNCEMENT BAR MARQUEE (optional, if multiple messages) ───────────────
  // Single static message — no marquee needed

  // Initial cart count on page load
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});

})();
